import { cloneElement, type ReactElement } from "react";

/**
 * Kendo's DropDownList/MultiSelect/ComboBox show a "NO DATA FOUND." popup
 * message when their data list is empty, but never announce it - a sighted
 * user sees the text appear, but nothing tells a screen reader user the list
 * came up empty.
 *
 * Uses role="alert" rather than role="status": Kendo creates this whole
 * element fresh, already containing its text, every time the popup opens.
 * role="status" (aria-live="polite") is unreliable for nodes that appear
 * already-populated like that - most screen readers only reliably announce
 * a "polite" live region when it already existed and its content changed
 * afterward. role="alert" (implicit aria-live="assertive") is built to
 * handle exactly this "appears fully formed" case, confirmed by testing
 * with a screen reader (role="status" here was silent, role="alert" is not).
 *
 * Pass to the `listNoDataRender` prop:
 * `<DropDownList listNoDataRender={accessibleNoDataRender("No program years available")} ... />`
 */
export function accessibleNoDataRender(message: string) {
  return (element: ReactElement<HTMLDivElement>) =>
    cloneElement(element, undefined, <span role="alert">{message}</span>);
}
